<app-layout [enableTopGap]="true">
  <section class="quiz-page" [class.q-intro]="intro">
    <div class="quiz-shell">
      <div *ngIf="!result" class="quiz-state">
        <i class="fas fa-clipboard-list" aria-hidden="true"></i>
        <span>{{ "quiz.results.empty" | translate }}</span>
        <a class="quiz-btn" [routerLink]="listLink">{{ "quiz.results.backToQuizList" | translate }}</a>
      </div>

      <ng-container *ngIf="result">
        <section class="result-summary" [class.passed]="result.passed">
          <i class="fas result-icon" [ngClass]="result.passed ? 'fa-check-circle' : 'fa-times-circle'" aria-hidden="true"></i>
          <div class="result-headline">
            <p class="result-ticket">
              {{ "quizes.ticket" | translate: { number: result.quizId } }}
              <span class="quiz-chip" [class.practice]="result.mode === 'practice'">{{ "quizes.mode." + result.mode | translate }}</span>
            </p>
            <h1>{{ (result.passed ? "quiz.passedTitle" : "quiz.failedTitle") | translate }}</h1>
            <p class="result-score">
              <strong [appCountUp]="result.score"></strong> / {{ result.totalQuestions }}
              <span>{{ "quiz.results.required" | translate: { count: result.minPassingScore } }}</span>
            </p>
            <p *ngIf="result.timeUp" class="result-timeup">
              <i class="fas fa-hourglass-end" aria-hidden="true"></i> {{ "quiz.timeIsUpTitle" | translate }}
            </p>
          </div>

          <dl class="result-stats">
            <div class="correct">
              <dt>{{ "quiz.results.correct" | translate }}</dt>
              <dd [appCountUp]="correctCount" countUpDelay="0" countUpDuration="0.7"></dd>
            </div>
            <div class="wrong">
              <dt>{{ "quiz.results.wrong" | translate }}</dt>
              <dd [appCountUp]="wrongCount" countUpDelay="0.08" countUpDuration="0.7"></dd>
            </div>
            <div>
              <dt>{{ "quiz.results.skipped" | translate }}</dt>
              <dd [appCountUp]="skippedCount" countUpDelay="0.16" countUpDuration="0.7"></dd>
            </div>
            <div><dt>{{ "quiz.results.time" | translate }}</dt><dd>{{ duration }}</dd></div>
          </dl>

          <div class="result-actions">
            <a class="quiz-btn" [routerLink]="[listLink, result.quizId]" [queryParams]="retryQueryParams">
              <i class="fas fa-redo" aria-hidden="true"></i> {{ "quiz.tryAgain" | translate }}
            </a>
            <button type="button" class="quiz-btn secondary" (click)="goBackToQuizList()">
              <i class="fas fa-th-large" aria-hidden="true"></i> {{ "quiz.results.backToQuizList" | translate }}
            </button>
          </div>
        </section>

        <div class="result-review-header">
          <h2>{{ "quiz.results.header" | translate }}</h2>
          <div class="quiz-segment" role="radiogroup" [attr.aria-label]="'quiz.results.header' | translate"
            [style.--seg]="filter === 'mistakes' ? 0 : 1">
            <button type="button" role="radio" [class.active]="filter === 'mistakes'" [attr.aria-checked]="filter === 'mistakes'"
              (click)="setFilter('mistakes')">
              {{ "quiz.results.mistakes" | translate }} ({{ mistakeCount }})
            </button>
            <button type="button" role="radio" [class.active]="filter === 'all'" [attr.aria-checked]="filter === 'all'"
              (click)="setFilter('all')">
              {{ "quiz.results.all" | translate }} ({{ items.length }})
            </button>
          </div>
        </div>

        <p *ngIf="!visibleItems.length" class="quiz-state">
          <i class="fas fa-star" aria-hidden="true"></i>
          <span>{{ "quiz.results.noMistakes" | translate }}</span>
        </p>

        <article *ngFor="let item of visibleItems; trackBy: trackByNumber" class="quiz-card result-item" [ngClass]="item.status"
          appReveal="fade" revealBatch>
          <p class="quiz-counter">
            <i class="fas" aria-hidden="true"
              [ngClass]="item.status === 'correct' ? 'fa-check' : item.status === 'wrong' ? 'fa-times' : 'fa-minus'"></i>
            {{ "quiz.questionOf" | translate: { current: item.number, total: items.length } }}
            · {{ "quiz.results.status." + item.status | translate }}
          </p>
          <h3 class="quiz-question" dir="auto">{{ item.question.question }}</h3>
          <app-quiz-image *ngIf="item.question.imagePath" [src]="item.question.imagePath"
            [alt]="'quiz.image_alt' | translate" [lazy]="true"></app-quiz-image>
          <ul class="quiz-options result-options">
            <li *ngFor="let option of item.options; let j = index" class="quiz-option locked"
              [class.correct]="j === item.question.correctAnswerIndex - 1"
              [class.wrong]="j === item.answer && j !== item.question.correctAnswerIndex - 1">
              <span class="quiz-option-badge" aria-hidden="true">{{ option.label }}</span>
              <span class="quiz-option-text" dir="auto">{{ option.text }}</span>
              <span *ngIf="j === item.answer" class="result-your-answer">{{ "quiz.results.yourAnswer" | translate }}</span>
              <i *ngIf="j === item.question.correctAnswerIndex - 1" class="fas fa-check quiz-option-icon"
                [attr.aria-label]="'quiz.results.correctAnswer' | translate"></i>
              <i *ngIf="j === item.answer && j !== item.question.correctAnswerIndex - 1" class="fas fa-times quiz-option-icon"
                aria-hidden="true"></i>
            </li>
          </ul>
        </article>
      </ng-container>
    </div>
  </section>
</app-layout>
